export const MainMenuItems = [
  {
    route: { name: 'promo' },
    title: 'Рішення',
    hash: '#connect-features',
  },
  {
    route: { name: 'promo' },
    title: 'Переваги',
    hash: '#possibilities',
  },
  {
    route: { name: 'promo' },
    title: 'Інтерфейс',
    hash: '#interface-slider',
  },
  {
    route: { name: 'promo' },
    title: 'Інтеграції',
    hash: '#integrations',
  },
  /*{
    route: { name: 'promo' },
    title: 'Відгуки',
    hash: '#feedbacks-slider',
  },*/
  {
    route: { name: 'promo' },
    title: 'Контакти',
    hash: '#contacts',
  },
  {
    route: { name: 'promo' },
    title: 'Презентація',
    hash: '#partners-information',
  },
  {
    url: '/resources/',
    title: 'Партнерам',
  },
];
